import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { DeclarationDocumentsEnum } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

export enum MutateDeclarationDocumentOperation {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
}

interface HookProps {
  doc: {
    operation: MutateDeclarationDocumentOperation;
    type: DeclarationDocumentsEnum;
    id: Record<string, string>;
    data?: any;
  };
  lrn: string;
  sequence: number;
}

export const useUpdateDeclarationDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ doc, lrn, sequence }: HookProps) => {
      const { data } = await request({
        path: `declarations/${doc.operation.toLowerCase()}-document`,
        method: 'PATCH',
        authenticate: true,
        dataObject: { lrn, sequence, document: doc },
      });

      return data;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', data._id] });
      toast.success('Declaration updated!');
    },
    onError: (error) => {
      showErrorToast(error, `Error updating the declaration!`);
    },
  });
};
